
import { defineComponent } from 'vue-demi';
import DashboardBrandManagement from './DashboardBrandManagement.vue';
import DashboardBrandManagementMobile from './DashboardBrandManagementMobile.vue';

export default defineComponent({
  components: {
    DashboardBrandManagement,
    DashboardBrandManagementMobile,
  },

  computed: {
    isMobilecp() {
      return this.$filters.isMobile();
    },
  },
});
